import {
  ComboBoxChangeEvent,
  ComboBoxFilterChangeEvent,
  MultiColumnComboBox,
} from "@progress/kendo-react-dropdowns";
import { filterBy, FilterDescriptor } from "@progress/kendo-data-query";
import * as React from "react";
import { useContext } from "react";
import { MultiColumnComboBoxProps } from "@progress/kendo-react-dropdowns/dist/npm/MultiColumnComboBox/MultiColumnComboBox";
import { getDropDownListOfValidShippingFrequencies } from "./GetDropDownListOfValidShippingFrequencies";
import { EditProjectContext } from "../../../EditProjectContext";
import { sortArrayBy } from "../../../../../Utils/arrays";

type Props = {
  onChange: ((event: ComboBoxChangeEvent) => void) | undefined;
  value: any;
  label: string | undefined;
};

export function SfMultiColumnDropDown({
  onChange,
  value,
  label,
  ...otherProps
}: Props & Partial<MultiColumnComboBoxProps>) {
  const editProjectContext = useContext(EditProjectContext);
  const { project } = editProjectContext;

  const shippingFrequencies = getDropDownListOfValidShippingFrequencies(
    project.ValidShippingFrequencies
  );
  const localizedData = sortValuesForShippingFrequencyIndividually(shippingFrequencies);

  const columns = [
    { field: "value", header: "SF", width: "45px" },
    { field: "text", header: "Description", width: "300px" },
  ];

  const [filter, setFilter] = React.useState<FilterDescriptor>();
  const handleFilterChange = (event: ComboBoxFilterChangeEvent) => {
    if (event) {
      setFilter(event.filter);
    }
  };

  return (
    <MultiColumnComboBox
      {...otherProps}
      onChange={onChange}
      value={localizedData.find((c) => c.value === value)}
      data={filter ? filterBy(localizedData, filter) : localizedData}
      columns={columns}
      clearButton={false}
      filterable
      onFilterChange={handleFilterChange}
      label={label}
      textField="value"
    />
  );
}

// customer wants to show rarely used shipping frequencies at the end of list
const sortValuesForShippingFrequencyIndividually = (sfList: { text: string; value: number }[]) => {
  const ascendingSortedList = sortArrayBy({ values: sfList, keyToSort: "value" });

  const sfForEndOfList = ascendingSortedList.filter(
    (sf) => sf.value === 12 || sf.value === 13 || sf.value === 19 || sf.value === 20
  );
  const withoutSfForEndOfList = ascendingSortedList.filter((sf) => !sfForEndOfList.includes(sf));

  return withoutSfForEndOfList.concat(sfForEndOfList);
};
